import { recordEventCustomOnly } from 'utilities/uTagging';

const recordXpressIdevent = ({ element, errorCategory, errorDescription }) => {
    recordEventCustomOnly({
        action: 'identify',
        format: 'iframe',
        component: 'verificationPlatform/veridas',
        element,
        errorCategory,
        errorDescription,
    });
};

export const doTagOnProcessCompletedEvent = () => {
    recordXpressIdevent({ element: 'completed' });
};

export const doTagOnProcessCancelledEvent = () => {
    recordXpressIdevent({ element: 'cancelled' });
};

export const doTagOnProcessInfoEvent = ({ infoEvent, code }) => {
    recordXpressIdevent({ element: infoEvent?.code || code });
};

export const doTagOnProcessErrorEvent = ({ code, message }) => {
    recordXpressIdevent({ element: code, errorCategory: code, errorDescription: message });
};
